<template>
  <div class="card-block small-paddings empty-btns">
    <button v-if="!emptySearch" class="btn btn-primary btn-sm" @click="showEmpty">
      Search for Empty Entities <span ref="showEmptyLoader" class="btn-loader" style="display: none;" />
    </button>
    <button v-else class="btn btn-primary btn-sm" @click="showAll">
      Search for All Entities <span ref="showAllLoader" class="btn-loader" style="display: none;" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    emptySearch: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    showEmpty() {
      this.$emit('showEmpty');
    },
    showAll() {
      this.$emit('showAll');
    },
  },
};
</script>



// WEBPACK FOOTER //
// EmptyBtns.vue?18da0fed